$(function() {
  function toTitleCase(str) {
    return str.toLowerCase().replace(/(?:^|[\s-/])\w/g, function (match) {
      return match.toUpperCase();
    });
  }

	function getValues$() {
		return $('input[id^="internal_user_value_"]')
	}
	function getValue$(id) {
		return $('#internal_user_value_'+ id)
	}
	function getIdFromValue$(value$) {
		return ((value$.get(0)||{}).id||'').replace('internal_user_value_', '')
	}
	function enable$($thing) {
		$thing.closest('.form-group').removeClass('disabled');
		return $thing.prop('disabled', false).removeClass('disabled').each(function(i, e) {
			if (e.selectize) {
				e.selectize.enable();
			}
		});
	}
	function disable$($thing) {
		$thing.closest('.form-group').addClass('disabled');
		return $thing.prop('disabled', true).addClass('disabled').each(function(i, e) {
			if (e.selectize) {
				e.selectize.disable();
			}
		});
	}

	function setVal$($thing, val) {
		return $thing.each(function(i, e) {
			if (e.type === 'checkbox') {
				$(e).prop('checked', Boolean(val))
			} else if (e.selectize) {
				if (val && val.length) {
					var values = (val || '').split(',');
					for (var i = 0; i < values.length; i++) {
						e.selectize.addOption({
							value: values[i],
							text: values[i]
						});
					}
					e.selectize.setValue(values);
				} else {
					e.selectize.clear();
				}
			} else {
				$(e).val(val);
			}
		})
	}

	function getPts$() {
		return $('input[id^="internal_user_pt_"]')
	}
	function getPt$(id) {
		return $('#internal_user_pt_' + id)
	}
	function getAppAndCodeFromPt$(thing) {
        return [$(thing).attr('data-application'), $(thing).attr('data-code')];
    }
	function getPt$ByCode(app, code) {
		return $('input[type=checkbox][data-application="' + app + '"][data-code="' + code + '"]')
	}
	function getIdFromPt$(pt$) {
		return ((pt$.get(0)||{}).id||'').replace('internal_user_pt_', '');
	}

	function clearResponse() {
		$('#result_div').addClass('hidden');
	}
	function setResponse(type, msg) {
		$('#result_message').text(msg);
		$('#result_div').removeClass('hidden alert-danger alert-success').addClass('alert-'+type);
	}

	function isEmailValid(email) {
		return /^([\w\-]+)\.([\w\-]+\.)*([\w\-]+)@owenscorning\.com$/.test(email);
	}

	getValues$().each(function(i, e) {
		var $e = $(e);
		$e.selectize({
			valueField: 'value',
			labelField: 'value',
			searchField: 'value',
			delimiter: ',',
			persist: false,
			create: function(input) {
				return {
					value: input,
					text: input
				}
			},
			load: function(query, callback) {
				if (!query.length) return callback();
				$.ajax({
					url: '/users/internal/'+ getIdFromValue$($e) + '/values',
					type: 'GET',
					dataType: 'json',
					data: {
						q: query
					},
					xhrFields: {
						withCredentials: true
					},
					error: function() {
						callback();
					},
					success: function(res) {
						var items = res.results.map(function(v) { return {value: v} });
						console.log(items);
						callback(items);
					}
				});
			}
		});
	});
	getPts$().on('change', function(e) {
		var $this = $(this);
		var $val = getValue$(getIdFromPt$($this));
        var appAndCode = getAppAndCodeFromPt$($this)

        if ($this.is(':checked')) {
            enable$($val);
            if (appAndCode[0] === 'MDMS' && (appAndCode[1] === 'PRODUCT_EDIT' || appAndCode[1] === 'PRODUCT_PUBLISH')) {
                var cmsLanguagePt = getPt$ByCode('MDMS', 'PRODUCT_CMS_LANGUAGE');
                setVal$(cmsLanguagePt, true)
                var $languageVal = getValue$(getIdFromPt$(cmsLanguagePt));
                setVal$(enable$($languageVal), '*');
            }
		} else {
			setVal$(disable$($val), '');
            if (appAndCode[0] === 'MDMS' && (appAndCode[1] === 'PRODUCT_EDIT' || appAndCode[1] === 'PRODUCT_PUBLISH')) {
                var cmsEditPt = getPt$ByCode('MDMS', 'PRODUCT_EDIT');
                var cmsPublishPt = getPt$ByCode('MDMS', 'PRODUCT_PUBLISH');
                if (!cmsEditPt.is(':checked') && !cmsPublishPt.is(':checked')) {
                    var cmsLanguagePt = getPt$ByCode('MDMS', 'PRODUCT_CMS_LANGUAGE');
                    setVal$(cmsLanguagePt, false)
                    var $languageVal = getValue$(getIdFromPt$(cmsLanguagePt));
                    setVal$(disable$($languageVal), '');
                }
            }
		}
	});
    function enablePts() {
        var allPts = enable$(getPts$());
        var cmsLanguagePt = getPt$ByCode('MDMS', 'PRODUCT_CMS_LANGUAGE');
        disable$(cmsLanguagePt);
        return allPts;
    }
    function resetPts() {
        return enablePts().prop('checked', false);
    }
    $('#internal_user_employee_id').selectize({
		valueField: 'unique_id',
		// labelField: 'employee_id',
		searchField: ['search_field'],
		options: [],
		create: false,
		render: {
			option: function(item, escape) {
				return '<div>' +
                        (item.employee_id === 0 ? '(contractor)' : escape(item.employee_id)) + '<br/>' +
						escape(item.last_name) + ', ' + escape(item.first_name) + ', ' + escape(item.email_address) + ', ' + escape(item.location_name) +
						'</div>'
			},
			item: function (item, escape) {
				return '<div>' +
						escape(item.last_name) + ', ' + escape(item.first_name) + ', ' + escape(item.email_address) +
						'</div>'
			}
		},
		load: function(query, callback) {
			if (!query.length) return callback();
			$.ajax({
				url: '/users/internal/employees',
				type: 'GET',
				dataType: 'json',
				data: {
					q: query
				},
				xhrFields: {
					withCredentials: true
				},
				error: function() {
					callback();
				},
				success: function(res) {
					callback(res.results);
				}
			});
		},
        onChange: function(value) {
		    var $selectize = $('#internal_user_employee_id')[0].selectize;
		    var object = $selectize.options[value];
        if(!object) return;

            disable$($('button[type="submit"]'));
            clearResponse();

            var employee_id = object.employee_id;
            var user_id = object.user_id;
            var email = object.email_address;
            if (employee_id === 0 && user_id === 0) {
                // new user, also not an employee
                $('#internal_user_first_name').val(object.first_name);
                $('#internal_user_last_name').val(object.last_name);
                $('#internal_user_email_address').val(email);
                $('#internal_user_hidden_id').val(null);
                resetPts();
                setVal$(getValues$(), '');
                enable$($('button[type="submit"]'));
            } else {
                $.ajax({
                    type: "GET",
                    url: "/users/internal/permissions",
                    data: {
                        email: email
                    },
                    success: function (response_data) {
                        $('#internal_user_first_name').val(response_data.data.first_name);
                        $('#internal_user_last_name').val(response_data.data.last_name);
                        $('#internal_user_email_address').val(response_data.data.email);
                        $('#internal_user_hidden_id').val(response_data.data.user_id);
                        resetPts();
                        setVal$(getValues$(), '');
                        var permissions = (response_data.data.permissions || []);
                        for (var i = 0; i < permissions.length; i++) {
                            var $pt = getPt$ByCode(permissions[i].application, permissions[i].code);
                            $pt.prop('checked', true);
                            var $val = getValue$(getIdFromPt$($pt));
                            setVal$(enable$($val), permissions[i].value);
                        }
                        enable$($('button[type="submit"]'));
                    }
                });
            }
        }
	});

 function resetForm() {
   $('#internal_user_first_name').val('');
   $('#internal_user_last_name').val('');
   $('#internal_user_email_address').val('');
   $('#internal_user_hidden_id').val('');
   resetPts();
   setVal$(getValues$(), '');
   disable$($('button[type="submit"]'));
   clearResponse();
 }

	$('input[name="action_type"]').change(function() {
		var actionType = $(this).val();

    resetForm();

		if (actionType === 'update') {
			// Show selectize dropdown for existing users
			$('#employee_select_container').show();

			// Reset selectize
			if ($('#internal_user_employee_id')[0].selectize) {
				$('#internal_user_employee_id')[0].selectize.clear();
			}

			// Make name and email fields readonly in update mode
			$('#internal_user_first_name').prop('readonly', true);
			$('#internal_user_last_name').prop('readonly', true);
			$('#internal_user_email_address').prop('readonly', true);
		} else {
			// Hide selectize dropdown for create mode
			$('#employee_select_container').hide();

			// Clear selectize if it exists
			if ($('#internal_user_employee_id')[0].selectize) {
				$('#internal_user_employee_id')[0].selectize.clear();
			}

			// Make name and email fields editable in create mode
			$('#internal_user_first_name').prop('readonly', false);
			$('#internal_user_last_name').prop('readonly', false);
			$('#internal_user_email_address').prop('readonly', false).focus();

			// Enable permissions
			enablePts();
		}

		// Check if there's already a valid email and enable button if so
		var email = $('#internal_user_email_address').val().trim();
		if (isEmailValid(email)) {
			enable$($('button[type="submit"]'));
		} else {
			disable$($('button[type="submit"]'));
		}
	});

	// Add handler for email input in create mode
	$('#internal_user_email_address').on('input', function() {
		if ($('input[name="action_type"]:checked').val() === 'update') {
			return;
		}

		var email = $(this).val().trim();
		clearResponse();

		if (!isEmailValid(email)) {
			disable$($('button[type="submit"]'));
			return;
		}

		// Try to extract name parts if in standard format
		if (email.split('@')[0].includes('.')) {
			var parts = email.split('@')[0].split('.');
			var firstName = toTitleCase(parts[0]);
			var lastName = toTitleCase(parts[parts.length - 1]);

			// Auto-suggest the names if they're empty
			if (!$('#internal_user_first_name').val()) {
				$('#internal_user_first_name').val(firstName);
			}
			if (!$('#internal_user_last_name').val()) {
				$('#internal_user_last_name').val(lastName);
			}
		}

		enable$($('button[type="submit"]'));
	});

	$('button.js-create-update').click(function(e) {
		var $button = $(this);
		if ($button.hasClass('disabled') ) {
			e.preventDefault();
			e.stopPropagation();
			return;
		}

		var form_contents = $('form').serializeArray();

		var actionType = $('input[name="action_type"]:checked').val();
		form_contents.push({name: 'action_type', value: actionType});

		if (actionType === 'update') {
			var selectizeInstance = $('#internal_user_employee_id')[0].selectize;
			var allOptions = selectizeInstance.options;
			var employee_id = allOptions[selectizeInstance.getValue()].employee_id;
			form_contents.find(content => (content.name === 'internal_user[employee_id]')).value = employee_id;
		} else {
			// Set employee_id to 0 for contractors/new users
			form_contents.find(content => (content.name === 'internal_user[employee_id]')).value = 0;
		}

		form_contents = $.param(form_contents);

		disable$($button).addClass('spinner-button');
		disable$(getPts$());
		disable$(getValues$());

		var success = false;
		$.ajax({
			type: "POST",
			url: "/users/internal",
			data: form_contents,
			success: function (response_data) {
				setResponse('success', 'Success!');
				success = true;

				if (actionType === 'create') {
					$('#internal_user_first_name').prop('readonly', true);
					$('#internal_user_last_name').prop('readonly', true);
					$('#internal_user_email_address').prop('readonly', true);
					disable$($('button[type="submit"]'));
				}

				// Scroll to the top of the page to show the success message
				$('html, body').animate({ scrollTop: 0 }, 'fast');
			},
			error: function (jqXHR, textStatus, errorThrown) {
				var errorMessage = 'Error saving changes!';

				if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
					errorMessage = jqXHR.responseJSON.error;
				}

				setResponse('danger', errorMessage);

				// Scroll to the top of the page to show the error message
				$('html, body').animate({ scrollTop: 0 }, 'fast');
			},
			complete: function() {
				enablePts().each(function(i, e) {
					var $pt = $(e);
					if ($pt.is(':checked')) {
						enable$(getValue$(getIdFromPt$($pt)));
					}
				});
				enable$($button).removeClass('spinner-button');

        // New user won't be editable after creation. Use the update mode to edit the user.
				if (success && actionType === 'create') {
					disable$($('button[type="submit"]'));
				}
			}
		});
	});

	$(document.body).on("click", "button.disabled", function(e) {
		e.preventDefault();
	});
});
